import React from "react";
import { classNames } from "primereact/utils";
import { DashlyControlSize, dashlyControlSizeClass } from "../shared/dashlyControlSize";
import "./DashlyFilterClearField.scss";

export type DashlyFilterClearFieldControlType = "text" | "select";

export type DashlyFilterClearFieldProps = {
    children: React.ReactNode;
    hasValue: boolean;
    onClear: () => void;
    clearLabel?: string;
    controlType?: DashlyFilterClearFieldControlType;
    /** Matches the wrapped control so trigger-width tokens align. */
    controlSize?: DashlyControlSize;
    className?: string;
};

export const DashlyFilterClearField: React.FC<DashlyFilterClearFieldProps> = ({
    children,
    hasValue,
    onClear,
    clearLabel = "Clear filter",
    controlType = "text",
    controlSize = "md",
    className,
}) => {
    const handleClear = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        onClear();
    };

    return (
        <div
            className={classNames(
                "dashly-filter-clear-field",
                dashlyControlSizeClass(controlSize),
                hasValue && `dashly-filter-clear-field--has-value--${controlType}`,
                controlType === "select" && "dashly-filter-clear-field--select",
                className,
            )}
        >
            <div className="dashly-filter-clear-field__control">{children}</div>
            {hasValue ? (
                <button
                    type="button"
                    className="dashly-filter-clear-field__clear"
                    aria-label={clearLabel}
                    title={clearLabel}
                    onClick={handleClear}
                >
                    <i className="pi pi-times" aria-hidden />
                </button>
            ) : null}
        </div>
    );
};
